// The learner's Azure Speech token comes from the assessment API, which keeps the
// subscription key on the server and answers { token, region }.
export const SPEECH_TOKEN_PATH = "/public/assessment/speech-token";

export async function fetchSpeechToken(baseUrl, fetchImpl = fetch) {
  const response = await fetchImpl(baseUrl + SPEECH_TOKEN_PATH, {
    method: "GET",
    mode: "cors",
    cache: "no-store",
  });
  if (!response.ok) {
    const body = await response.text().catch(() => "");
    throw new Error(
      `Token fetch failed: ${response.status} ${response.statusText} ${body}`.trim(),
    );
  }
  const data = await response.json();
  if (!data?.token || !data?.region) {
    throw new Error("Token fetch failed: no token in the response");
  }
  return { token: data.token, region: data.region };
}
